"use client"

import { useEffect, useState } from "react"

const order = { sm: 0, md: 1, lg: 2, xl: 3 }

export function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState<"sm" | "md" | "lg" | "xl">("xl")
  const [windowWidth, setWindowWidth] = useState<number>(0)
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
      if (window.innerWidth < 960) {
        setBreakpoint("sm")
      } else if (window.innerWidth < 1440) {
        setBreakpoint("md")
      } else if (window.innerWidth < 1660) {
        setBreakpoint("lg")
      } else {
        setBreakpoint("xl")
      }
    }
    handleResize()
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const isScreenLessThan = (size: "sm" | "md" | "lg" | "xl") => {
    return order[breakpoint] < order[size]
  }

  const isScreenMoreThan = (size: "sm" | "md" | "lg" | "xl") =>
    order[breakpoint] >= order[size]

  return { breakpoint, isScreenLessThan, isScreenMoreThan, windowWidth }
}
